module.exports = __webpack_public_path__ + "static/media/phyxable+online+physiotherapy+consultation.1e4c8852.png";